export default __webpack_public_path__ + "static/sketch3-9624defbcc086f04aecf18438d1460f0.jpg";